import { Fetch } from 'react-common/services';

export function getCountriesList() {
  return Fetch.getJSON(`/api/cometa/country`);
}
